import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './ContentRowTipjar.module.css';

const ContentRowTipJar = (props) => {
  const { id, tipJar, setIsEdited, className } = props;
  const [sTipJar, setTipJar] = useState(tipJar);

  useEffect(() => {
    setTipJar(props.tipJar);

    return () => props.setIsEdited(false);
  }, [tipJar, setIsEdited]);

  const handleChange = (e) => {
    setTipJar({
      ...sTipJar,
      [e.target.name]: e.target.value,
    });
  };

  const isChanged = !(
    tipJar.low === sTipJar.low &&
    tipJar.med === sTipJar.med &&
    tipJar.high === sTipJar.high
  );

  const handleBlur = () => {
    if (isChanged) {
      props.setIsEdited(true);
      props.onTipJarChange(sTipJar);
    } else {
      console.log('change price to submit!');
    }
  };

  const classes = `${className} ${styles.tipjar}`;
  return (
    <>
      <td className={classes}>
        <input
          id={`low_${id}`}
          type="number"
          name="low"
          min="0"
          step="0.01"
          onChange={handleChange}
          onBlur={handleBlur}
          value={sTipJar.low}
          className={styles['contentrowprice-input']}
        />
      </td>
      <td className={classes}>
        <input
          id={`mid_${id}`}
          type="number"
          name="med"
          min="0"
          step="0.01"
          onChange={handleChange}
          onBlur={handleBlur}
          value={sTipJar.med}
          className={styles['contentrowprice-input']}
        />
      </td>
      <td className={classes}>
        <input
          id={`high_${id}`}
          type="number"
          name="high"
          min="0"
          step="0.01"
          onChange={handleChange}
          onBlur={handleBlur}
          value={sTipJar.high}
          className={styles['contentrowprice-input']}
        />
      </td>
    </>
  );
};

ContentRowTipJar.propTypes = {
  id: PropTypes.node.isRequired,
  tipJar: PropTypes.node.isRequired,
  setIsEdited: PropTypes.node.isRequired,
  onTipJarChange: PropTypes.node.isRequired,
  className: PropTypes.node.isRequired,
};

export default ContentRowTipJar;
